<template>
  <div>
    <label>
      <span>{{$t('printers.modal.editHost.title')}}</span>
      <input type="text" class="inp" v-model="name">
    </label>
    <label>
      <span>{{$t('printers.modal.editHost.location')}}</span>
      <b-button variant="-secondary">{{$t('printers.modal.editHost.setLocation')}}</b-button>
    </label>
    <color-picker v-model="color"></color-picker>
  </div>
</template>

<script>

  import {mapActions} from 'vuex';

  import ColorPicker from "../../ColorPicker";

  export default {
    name: 'edit-host',
    props: ['hostId', 'hostName', 'hostColor'],
    components: {
      ColorPicker
    },
    data() {
      return {
        name: '',
        color: ''
      }
    },
    created() {
      this.name = this.hostName;
      this.color = this.hostColor ? this.hostColor : '';
    },
    methods: {
      ...mapActions(['setHostName', 'setHostColor']),

      handleEditHost(ok) {
        if (this.name !== this.hostName) {
          this.setHostName({
            hostId: this.hostId,
            name: this.name
          }).then(({data}) => {
            if (data.result) {
              ok();
            } else {
              this.msgBoxOk(data.message);
            }
          }).catch(() => {
            this.msgBoxOk(this.$t('printers.modal.editHost.errorEditHost'));
          });
        }

        const currentHostColor = this.hostColor ? this.hostColor : '';
        if (this.color !== currentHostColor) {
          this.setHostColor({
            hostId: this.hostId,
            color: this.color
          }).then(({data}) => {
            if (data.result) {
              ok()
            } else {
              this.msgBoxOk(data.message);
            }
          }).catch(() => {
            this.msgBoxOk(this.$t('printers.modal.editHost.errorEditColor'));
          })
        }
      }
    }
  }
</script>